import { AxiosResponse } from 'axios';
import api from './api';
import { CreateNode, DbNode } from '../types/node';

function path(endPath: string): string {
    return `/node${endPath}`;
}

export class NodeService {
    static async getById(nodeId: number): Promise<AxiosResponse> {
        return api.get(path(`/node/${nodeId}`));
    }

    static async getNodes(nodeId: number): Promise<AxiosResponse> {
        return api.get(path(`/${nodeId}`));
    }

    static async path(nodeId: number): Promise<AxiosResponse> {
        return api.get(path(`/path/${nodeId}`));
    }

    static async create(node: CreateNode): Promise<AxiosResponse> {
        return api.put(path('/'), node);
    }

    static async edit(node: DbNode): Promise<AxiosResponse> {
        return api.post(path('/'), node);
    }

    static async remove(nodeId: number): Promise<AxiosResponse> {
        return api.delete(path(`/${nodeId}`));
    }
}
